// src/data.js

// Fees & Expenses Bar Chart Data
export const barData = [
  { day: "01", fee: 3000, expense: 500 },
  { day: "02", fee: 1000, expense: 200 },
  { day: "03", fee: 1500, expense: 400 },
  { day: "04", fee: 2800, expense: 600 },
  { day: "05", fee: 2200, expense: 350 },
  { day: "06", fee: 1800, expense: 450 },
  { day: "07", fee: 2500, expense: 700 },
  { day: "08", fee: 3200, expense: 800 },
  { day: "09", fee: 2900, expense: 500 },
  { day: "10", fee: 1400, expense: 300 },
  { day: "11", fee: 2000, expense: 600 },
  { day: "12", fee: 2600, expense: 450 },
  { day: "13", fee: 1700, expense: 400 },
  { day: "14", fee: 3100, expense: 700 },
  { day: "15", fee: 2800, expense: 650 },
  { day: "16", fee: 2200, expense: 500 },
  { day: "17", fee: 2600, expense: 550 },
  { day: "18", fee: 3000, expense: 800 },
  { day: "19", fee: 1900, expense: 350 },
  { day: "20", fee: 2400, expense: 600 },
  { day: "21", fee: 2700, expense: 700 },
  { day: "22", fee: 1500, expense: 300 },
  { day: "23", fee: 2300, expense: 500 },
  { day: "24", fee: 2000, expense: 450 },
  { day: "25", fee: 2800, expense: 750 },
  { day: "26", fee: 3100, expense: 900 },
  { day: "27", fee: 1700, expense: 400 },
  { day: "28", fee: 2200, expense: 500 },
  { day: "29", fee: 2500, expense: 600 },
  { day: "30", fee: 2900, expense: 800 },
  { day: "31", fee: 3300, expense: 950 },
];

// Income Pie Chart Data
export const incomeData = [
  { name: "Donation", value: 400 },
  { name: "Rent", value: 300 },
  { name: "Miscellaneous", value: 300 },
  { name: "Book Sale", value: 200 },
  { name: "Uniform Sale", value: 150 },
];

// Expense Pie Chart Data
export const expenseData = [
  { name: "Stationery", value: 240 },
  { name: "Electricity Bill", value: 300 },
  { name: "Telephone Bill", value: 100 },
  { name: "Miscellaneous", value: 150 },
  { name: "Flower", value: 120 },
];
